import { useMemo } from 'react'
import { useKpiDimStackable } from '~/api/hooks/useCatalog'
import { resolveSeriesAdditivity, type AdditivityVerdict } from './seriesAdditivity'

/** React seam of the additivity resolver: fetch (cached, staleTime ∞) the fact's
 *  v_kpi_dim_stackable rows and resolve. Every consumer that renders a ChartCanvas must
 *  call this (or resolveSeriesAdditivity directly in non-hook contexts). */
export function useSeriesAdditivity(
  factTable: string | null,
  kpi: string,
  groupBy: string[],
  effectiveValueTypes: string[],
): AdditivityVerdict {
  const stack = useKpiDimStackable(factTable)
  return useMemo(
    () =>
      resolveSeriesAdditivity({
        groupBy,
        effectiveValueTypes,
        stackableRows: stack.data,
        kpi,
      }),
    [groupBy, effectiveValueTypes, stack.data, kpi],
  )
}
